export enum DocumentacaoImovel {
  RECIBO_COMPRA_VENDA = 'RECIBO_COMPRA_VENDA',
  CONTRATO_PROMESSA_COMPRA_VENDA = 'CONTRATO_PROMESSA_COMPRA_VENDA',
  ESCRITURA = 'ESCRITURA',
  IPTU = 'IPTU',
  OUTRO = 'OUTRO',
}
